/* MOUD — affiche dans « Ajouter au panier » le prix de l'offre Kaching sélectionnée
   et son prix barré : « Ajouter au panier – 48 € 59 € ».
   Kaching met à jour .kaching-bundles__bar-price / -full-price à chaque changement de pack
   ou de formule (abonnement / achat unique) ; on les recopie dans le bouton. */
(function () {
  function init(bundle) {
    var form = bundle.closest('section, .shopify-section') || document;
    var button = form.querySelector('.product-form__submit');
    if (!button) return;
    var label = button.querySelector('span');
    if (!label) return;

    var pending = false;
    function render() {
      pending = false;
      if (button.disabled) return; // épuisé / indisponible : on laisse le texte de Dawn
      var bar = bundle.querySelector('.kaching-bundles__bar--selected:not(:has(.kaching-bundles__subscriptions__card))');
      var price = bar && bar.querySelector('.kaching-bundles__bar-price');
      if (!price) return;
      var full = bar.querySelector('.kaching-bundles__bar-full-price');
      var html =
        'Ajouter au panier<span class="moud-atc__sep"> – </span>' +
        '<span class="moud-atc__price">' + price.textContent.trim() + '</span>' +
        (full && full.textContent.trim()
          ? ' <s class="moud-atc__full">' + full.textContent.trim() + '</s>'
          : '');
      if (label.innerHTML !== html) label.innerHTML = html;
    }
    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(render);
    }

    new MutationObserver(schedule).observe(bundle, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    // Dawn réécrit le libellé (ajout au panier, changement de variante) : on repasse derrière.
    new MutationObserver(schedule).observe(label, { childList: true, characterData: true, subtree: true });
    schedule();
  }

  function start() {
    document.querySelectorAll('kaching-bundle').forEach(function (bundle) {
      if (bundle.dataset.moudAtc) return;
      bundle.dataset.moudAtc = '1';
      init(bundle);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // Kaching s'hydrate après le chargement
  window.addEventListener('load', start);
  setTimeout(start, 2500);
})();
